module.exports = __webpack_public_path__ + "assets/img/Type E (76).fd498f7d.jpg";